import React from 'react';
import { AttributesT } from '../../utils/constants';
import { BumperWidth } from '../AttributeComponents/BumperWidth/BumperWidth';
import { FrontBumper } from '../AttributeComponents/FrontBumper/FrontBumper';
import { JeepType } from '../AttributeComponents/JeepType/JeepType';
import { PaintColor } from '../AttributeComponents/PaintColor/PaintColor';
import { RearBumper } from '../AttributeComponents/RearBumper/RearBumper';
import { Tires } from '../AttributeComponents/Tires/Tires';
import { Wheels } from '../AttributeComponents/Wheels/Wheels';
import { Door } from '../AttributeComponents/Door/Door';
import { Mirror } from '../AttributeComponents/Mirror/Mirror';
import { HoodCatcher } from '../AttributeComponents/HoodCatcher/HoodCatcher';
import { LightBar } from '../AttributeComponents/LightBar/LightBar';
import { SideSteps } from '../AttributeComponents/SideSteps/SideSteps';
import s from './ComponentControl.module.scss';

export const ComponentControl = ({ ...props }) => {
  const attr: AttributesT = props.attr;
  if (attr === 'Jeep Type') {
    return <JeepType name={attr} />;
  } else if (attr === 'Front Fender') {
    return <BumperWidth name={attr} />;
  } else if (attr === 'Rear Fender') {
    return <BumperWidth name={attr} />;
  } else if (attr === 'Front Bumper') {
    return <FrontBumper name={attr} />;
  } else if (attr === 'Paint color') {
    return <PaintColor name={attr} />;
  } else if (attr === 'Rear Bumper') {
    return <RearBumper name={attr} />;
  } else if (attr === 'Tire') {
    return <Tires name={attr} />;
  } else if (attr === 'Wheels') {
    return <Wheels name={attr} />;
  } else if (attr === 'Door') {
    return <Door name={attr} />;
  } else if (attr === 'Mirror') {
    return <Mirror name={attr} />;
  } else if (attr === 'Hood Catcher') {
    return <HoodCatcher name={attr} />;
  } else if (attr === 'Light Bar') {
    return <LightBar name={attr} />;
  } else if (attr === 'Side Steps') {
    return <SideSteps name={attr} />;
  } else {
    return <></>;
  }
};
